export const roleOptions = [
    { label: 'User', value: 1 },
    { label: 'Super User', value: 4 },
    { label: 'Admin', value: 5 },
    { label: 'Owner', value: 6, isDisabled: true },
]
